<template>
    <div class="wrap">
        <div class="title">
            <div class="title_left">检测异常预警
                <el-popover placement="right" width="600" trigger="hover" popper-class="cc-popover" >
                    <i slot="reference" class="el-icon-warning"></i>
                    检测异常预警是指一定周期内，主体累计检测结果2次不合格，则产生检测超标预警，主体检测率低于50%，则产生多次未检预警；且都默认扣X分
                </el-popover>
            </div>
        </div>
        <div class="innerBox">
            <div class="page-card mb20 mt20 clear_a">
                <div>
                    <p class="number">{{detailData.ewProcessedNum}}</p>
                    <p class="text">已经处理预警数</p>
                </div>
                <div>
                    <p class="number">{{detailData.ewCurrentNum}}</p>
                    <p class="text">当前预警数</p>
                </div>
                <div>
                    <p class="number">{{detailData.deduction}}</p>
                    <p class="text">当前总扣分</p>
                </div>
                <div>
                    <p class="number">{{detailData.deductionLimit}}</p>
                    <p class="text">扣分上限</p>
                </div>
                <div>
                    <p class="number">{{detailData.actualDeduction}}</p>
                    <p class="text">实际总扣分</p>
                </div>
            </div>
            <div class="ipt-btn-box mb20">
                <el-input placeholder="处理人" class="w250 mr20 seekIpt" v-model="tableLimit.keyword"
                    @keyup.enter.native="handleIconClick">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="handleIconClick"></i>
                </el-input>
                <el-select class="mr20" v-model="tableLimit.handleStatus" @change="searchTab" placeholder="请选择处理状态" clearable>
                    <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-select class="mr20" v-model="tableLimit.handleType" @change="searchTab" placeholder="请选择处理方式" clearable>
                    <el-option v-for="(value,key) in handleType" :key="value" :label="value" :value="key"></el-option>
                </el-select>
                <el-select class="mr20" v-model="tableLimit.handleDept" @change="searchTab" placeholder="请选择处理部门" clearable>
                    <el-option v-for="(value,key) in disposeDept" :key="value" :label="value" :value="key"></el-option>
                </el-select>
                <el-select class="mr20" v-model="tableLimit.ewType" @change="searchTab" placeholder="请选异常类型" clearable>
                    <el-option v-for="item in ewType" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <span class="mr10">预警日期:</span>
                <el-date-picker @change="searchTab" value-format="yyyy-MM-dd" class=" w140 mr10" type="date"
                    v-model="tableLimit.startDate" clearable placeholder="选择开始日期" :picker-options="beforeDate">
                </el-date-picker>
                <span>至</span>
                <el-date-picker @change="searchTab" value-format="yyyy-MM-dd" v-model="tableLimit.endDate"
                    class=" w140 ml10 mr20" type="date" clearable placeholder="选择截止日期" :picker-options="afterDate">
                </el-date-picker>
                <el-checkbox v-model="tableLimit.showOnlyDeductions" @change=searchTab style="line-height:34px;">
                    仅显示扣分项
                </el-checkbox>
            </div>
            <div class="table mb20">
                <el-table v-loading="loading" element-loading-text="数据正在努力加载中" :border="true" :resizable="true"
                          :data="tableData" class="table-div" @sort-change="sortChange">
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="pdtName" min-width="190" label="检测异常类型">
                        <template slot-scope="scope">{{warning[scope.row.type]}}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="detectWay" min-width="120" label="检测方式"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="deliveDate" min-width="100" label="检测异常日期"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="detCnt" min-width="100" label="当日配送商品检测批次数"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="shouldDetCnt" min-width="100" label="当日配送商品应检测批次数"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="detRate" min-width="100" label="当日配送商品检测率"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="unquaCnt" min-width="100" label="当日检测不合格数" sortable='custom'></el-table-column>
                    <el-table-column show-overflow-tooltip prop="ewDate" min-width="100" label="预警时间" sortable='custom'></el-table-column>
                    <el-table-column show-overflow-tooltip prop="deduction" min-width="80" label="扣分"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100" label="处理状态">
                        <template slot-scope="scope">{{scope.row.handleStatus == 1? '已处理': '未处理'}}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100" label="处理方式">
                        <template slot-scope="scope">{{handleType[scope.row.handleType]}}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100" label="处理部门">
                        <template slot-scope="scope">{{handleDept[scope.row.handleDept]}}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="handlePerson" min-width="100" label="处理人"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="handleTime" min-width="100" label="处理时间"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100" prop="handleRemark" label="处理备注"></el-table-column>
                    <el-table-column min-width="100" label="处理附件">
                        <template slot-scope="scope">
                            <div v-if='scope.row.urlList_.length>0' style="width: 100px; height: 100px">
                                <el-image style="width: 100px; height: 100px" :src="scope.row.urlList_[0]"
                                    :preview-src-list="scope.row.urlList_">
                                </el-image>
                            </div>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="操作" min-width="150" fixed="right">
                        <template slot-scope="scope">
                            <a href="javascript:;" class="operate-a" v-if="scope.row.handleStatus == 0"
                               @click="dispose('dispose',scope.row)">处理</a>
                            <a href="javascript:;" class="operate-a" v-if="scope.row.handleStatus == 1"
                               @click="dispose('review',scope.row)">重新处理</a>
                        </template>
                    </el-table-column> -->
                </el-table>
                <div class="pagination-box">
                    <el-pagination background @size-change="pageSizeChange" @current-change="pageCurrentChange"
                                   :current-page="tableLimit.current" :page-sizes="[10, 20, 30, 40,50]"
                                   :page-size="tableLimit.size" layout="total, sizes, prev, pager, next, jumper"
                                   :total="page.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <Dialog :dialogData="dialogData" url="/ew/entity/detect/handle" :showTip="disposeAddDialog"
            v-if="disposeAddDialog" disposeType='01' @refresh="refreshData" @cancel="closeDialog">
        </Dialog>
    </div>

</template>

<script>
    import * as guard from "api/warn";
    import {getMapping} from "./public/mapping";
    import Dialog from './public/disposeDialog'

    export default {
        components: {
            Dialog
        },
        computed: {
            schoolTraceBaseUrl() {
                return this.$store.state.common.baseUrl
            },
        },
        data() {
            return {
                page: {
                    total: 0
                },
                warnDate: '',
                title: '',
                dialogData: {
                    id: '',
                    title: '',
                    handlePerson: '',
                    handleRemark: '',
                    defaultDeduction: 0
                },
                disposeAddDialog: false,
                loading: false,
                tableData: [],
                detailData: {},
                queryLimit: {
                    ewType: 'DETECTION_ABNORMAL'
                },
                tableLimit: {
                    current: 1,
                    endDate: '',
                    handleStatus: '',
                    handleType: '',
                    ewType: '',
                    keyword: '',
                    showOnlyDeductions: false,
                    size: 10,
                    startDate: '',
                    ewDateOrder: "DESC",
                    handleDept: ''
                },
                type: getMapping().type,
                handleType: getMapping().handle,
                disposeDept: getMapping().disposeDept,
                warning: getMapping().warning,
                handleDept: getMapping().disposeDept,
                ewType: [{
                    value: "020101",
                    label: "检测超标"
                },{
                    value: "020102",
                    label: "多次未检"
                }],
                statusOptions: [{
                        label: "已处理",
                        value: 1
                    },
                    {
                        label: "未处理",
                        value: 0
                    }
                ],
                beforeDate: {
                    disabledDate: (time) => {
                        let endDate = new Date(this.tableLimit.endDate);
                        let date = new Date('2018-12-31');
                        if (this.tableLimit.endDate) {
                            return time.getTime() > endDate || time.getTime() < date || time.getTime() > Date
                                .now() - 8.64e6
                        } else {
                            return time.getTime() < date || time.getTime() > Date.now() - 8.64e6
                        }
                    }
                },
                afterDate: {
                    disabledDate: (time) => {
                        let startDate = new Date(this.tableLimit.startDate);
                        let date = new Date('2018-12-31');
                        if (this.tableLimit.startDate) {
                            return time.getTime() < startDate - 8.64e7 || time.getTime() < date || time.getTime() >
                                Date.now() - 8.64e6;
                        } else {
                            return time.getTime() < date || time.getTime() > Date.now() - 8.64e6
                        }
                    }
                },
            };
        },
        async mounted() {
            this.getDetailData();
            this.searchTab();
        },
        methods: {
            refreshData() {
                this.getDetailData();
                this.searchTab();
            },
            handleIconClick() { //搜索框按钮点击搜索
                this.a = !this.a;
                this.searchTab();
            },
            async getDetailData() {
                this.loading = true;
                let result = await guard.getEwSummary(this.queryLimit)
                if (result.code == 200) {
                    this.detailData = result.data
                    if (result.data.streetAreaName !== null) {
                        this.detailData.areaName = `${result.data.areaName}${result.data.streetAreaName}`
                    }
                } else {
                    this.$message.warning(result.message);
                }
                this.loading = false;
            },
            sortChange(column) {
                if (column.order == "ascending") {
                    this.tableLimit.ewDateOrder = "ASC";
                }
                if (column.order == "descending") {
                    this.tableLimit.ewDateOrder = "DESC";
                }
                this.searchTab();
            },
            async searchPage() {
                this.loading = true;
                let result = await guard.getEwDetectExpired(this.tableLimit)
                if (result.code == 200) {
                    this.tableData = [];
                    result.data.records.map(item1 => {
                        if (item1.urlList.length > 0) {
                            let arr = item1.urlList.map(item => this.schoolTraceBaseUrl + '/' + item
                                .fileUrl)
                            this.$set(item1, 'urlList_', arr)
                        } else {
                            this.$set(item1, 'urlList_', [])
                        }
                        this.tableData.push(item1)
                    })
                    this.page.total = result.data.total
                } else {
                    this.$message.warning(result.message);
                }
                this.loading = false;
            },
            searchTab() {
                this.tableLimit.current = 1;
                this.searchPage();
            },
            pageCurrentChange(num) {
                this.tableLimit.current = num;
                this.searchPage();
            },
            pageSizeChange(size) {
                this.tableLimit.size = size;
                this.searchPage();
            },
            dispose(type, row) {
                if (type == 'review') {
                    this.dialogData.title = '重新处理'
                    this.dialogData.handleRemark = row.handleRemark;
                    this.dialogData.handlePersonName = row.handlePersonName;
                    this.dialogData.fidList = row.urlList;
                } else if (type == 'dispose') {
                    this.dialogData.title = '预警处理'
                }
                this.dialogData.id = row.id
                this.dialogData.defaultDeduction = row.defaultDeduction
                this.disposeAddDialog = true;
            },
            closeDialog() {
                this.disposeAddDialog = false;
            }
        }
    };
</script>
<style scoped lang="scss">
    .wrap {
        width: calc(100% - 40px);
        padding: 0 20px;
        height: 100%;
        background: #f6f6f6;

        .title {
            height: 60px;
            line-height: 60px;

            .title_left {
                font-size: 20px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                width: 50%;
                height: 100%;

                .el-icon-warning{
                    color: #e6a23c;
                    cursor: pointer;
                }
            }
        }

        .innerBox {
            width: calc(100% - 60px);
            padding: 20px 30px;
            min-height: calc(100% - 125px);
            background: #fff;
            border-radius: 10px;
            margin-bottom: 30px;
        }
    }

    .pagination-box {
        text-align: right;
        margin-top: 20px;
    }

    .table-div {
        width: 100%;
        text-align: center;
    }

    .operate-a {
        color: #1787ad;
    }

    table tr td:last-child .cell a {
        border-right: 1px solid #ccc;
        padding-right: 5px;
    }

    table tr td:last-child .cell a:last-child {
        border-right: none;
        padding-right: 0px;
    }

    .page-card {
        height: 100px;
        border: 1px solid rgba(194, 202, 210, 1);

        >div {
            height: 100%;
            width: 20%;
            text-align: center;

            p.number {
                font-size: 28px;
                font-weight: 500;
                color: rgba(57, 57, 57, 1);
                line-height: 40px;
                margin-bottom: 10px;
                margin-top: 10px;
            }

            p.text {
                font-size: 14px;
                font-weight: 400;
                color: rgba(162, 170, 182, 1);
                line-height: 20px;
            }
        }
    }
    .dialogImage {
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0
    }
    .table{
        padding-bottom: 100px;
    }
</style>

<style>
 .cc-popover{
    padding: 15px 20px;
    /* background-color: #fdf6ec; */
    color: #e6a23c;
}
</style>